module.exports = __webpack_public_path__ + "media/_/_/_/siqmain/app/javascript/components/images/proofpoint_logo-117e2b50733ffd94a6d8356934e6ea05.svg";